// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__2a2V+","icon":"mimic___style_icon__vwFwX","circle":"mimic___style_circle__Jlph+","sm":"mimic___style_sm__5b-l4","md":"mimic___style_md__7TWQA"};